
     localStorage.removeItem('localBOD');
     localStorage.removeItem('BOD');
     localStorage.removeItem('localOptionBOD');
     localStorage.removeItem('localFuture'); 
    
    $('#nav-icon2').click(function(){
      $(this).toggleClass('open');
      $('.upstox-logo').css({'display':'none'});
      if (!$(this).hasClass('open')) {
        $('.mega-sub-menu').css({'display':'none'});
        $('.mega-menu-item').removeClass('mega-toggle-on-new');
        $('.panel-logo').css({'display':'none'});
        $('.upstox-logo').css({'display':'inline-block'});
      }
    });

    if ($(window).width() >= 768 && $(window).width() <= 1279) {

      $(document).on('click', '.mega-menu-hover-dropdown', function () {
          $(this).addClass('mega-toggle-on mega-toggle-on-new');      
          $(this).find('.mega-sub-menu').show();
        });
        

        $(document).on('click', '.mega-toggle-on-new', function () {
          $(this).removeClass('mega-toggle-on mega-toggle-on-new');    
          $(this).find('.mega-sub-menu').hide();
        });

    }

    var scrollPos = $(window).scrollTop(),
        isArticle = $('.navigation').hasClass('article-page');

    if(!isArticle){
      changeHeader(scrollPos);
    }

    $(window).on('scroll', function () {
      var scrollPos = $(window).scrollTop();
      if(!isArticle){
        changeHeader(scrollPos);
      }
    });


    $(window).resize(function() {
      if($(window).width() > 1279) {
           $(document).on("mouseenter", ".mega-sub-menu .mega-menu-item a", function(){
            $('.mega-sub-menu .mega-menu-item a').hover(function() {
                $(this).addClass('navbar-link-item-hover');
                $('#pricingbtn a').removeClass('navbar-link-item-hover');
            }, function() {
                $('#pricingbtn a').removeClass('navbar-link-item-hover');
                $('.mega-sub-menu .mega-menu-item a').removeClass('navbar-link-item-hover');
            });
          });
          $("#mega-menu-primary_navigation").on("mouseenter", function() {
            // $(".inner").addClass("result_hover")
          }).on("mouseleave", function() {
              $(".inner").removeClass("result_hover")
              // timeout = setTimeout(function () {
              //   $('.inner').removeClass('result_hover');
              // }, 200);
          });
      }
  }).resize();

  document
  .querySelectorAll(".no-hover").forEach(function(item) {
    item.addEventListener('mouseover', function() {
      document.querySelector(".inner").classList.remove("result_hover");
    });
  })

  document
  .querySelector(".nav-bar_Product_and_Tools")
  .addEventListener('mouseover', function() {
    document.querySelector(".inner").classList.add("result_hover");
  });

  Array
  .from(document.querySelectorAll('.mega-menu-hover-dropdown'))
  .forEach((item) => item.addEventListener('mouseover', function() {
    document.querySelector(".inner").classList.add("result_hover");
  }));

    $(".nav-menu-button").on('click', function(){
        panelAnimate();
    });

    $('body').on('click','.panel-backdrop',function(){
        panelAnimate();
    });

    var windowUrl      = window.location.href;

    setTimeout(function(){
      var referredLink = windowUrl.indexOf("?ref=in");
      if(referredLink > -1){
          $("#redirectionPopup").show();
      }
    },1000);

    $(document).keyup(function(e) {
         if (e.keyCode == 27) {
          closeModal();
        }
    });

    $(".close").on('click',function(){
       closeModal();
    });


    $("body").on('click',"#showall-article",function(){
       $(".tocmodalDialog").show();
    });

    $(".explorebtn").on("click",function(){
        var prod_section=$(".products_section").offset().top;
        $("html, body").animate({ scrollTop: prod_section - 150 }, 800);
    });


    var wt = $(window).outerWidth();
    $(window).resize(function(){
        if($(document).outerWidth() >= 1281 && wt != $(window).outerWidth()){
            $("body").removeClass('no-scroll');
            $('.nav-links').removeClass('is-shown panelAnimate').removeAttr("style");
            $('.panel-backdrop').remove();
            $('.panel-logo').hide();
            $('.page-container,header.navigation,.contact-info,footer').removeClass("translateBody");
        }
        else if ($(document).outerWidth() < 1281){
            if(wt == $(window).outerWidth()){
              //$(".nav-links.panelAnimate").height($(window).height() + 70);
              return false;
            }
            else{
              $(".nav-links").removeClass('panelAnimate');
              $(".panel-backdrop").trigger('click');
              $(".nav-links.panelAnimate").height($(window).height());
              $("header.pro .nav-links.panelAnimate").height($(window).height()-60);
              if($('.nav-links').length && !($('.nav-links').hasClass('is-shown'))){
                $('.panel-backdrop').remove();
                $('.panel-logo').hide();
            }

          }
        }

    });


    $("body").on("click",".getTheApp",function(){
      // DetectAndServe();
      if(location.hostname === "upstox.bond"){
        window.open("https://wa.me/+917092362098","_self");
      }else{
        window.open("/open-demat-account/","_self");
      }

    });

    $('a').not('[href*="mailto:"], [href*="tel:"], [href*="#"], [href^="/"]').each(function () {
      var mylink = new RegExp('/' + window.location.host + '/');
      if ( ! mylink.test(this.href) ) {
        $(this).attr('target', '_blank');
      }
    });

    function closeModal(){
      $(".modalDialog, .tocmodalDialog, .modalDialog1").css({"display":"none"});
    }


    function panelAnimate(){

      $('body').toggleClass('no-scroll');
      $('.nav-links').toggleClass('is-shown');
      if($(document).outerWidth() >= 1281){
        $(".nav-links").removeClass('panelAnimate');
      }
      else{
        $(".nav-links").addClass('panelAnimate');
      }
      $(".nav-links.panelAnimate").height($(window).height() + 70);
      $("header.pro .nav-links.panelAnimate").height($(window).height()-60);
      if($('.nav-links').hasClass('is-shown')){
         $('.panel-logo').show();
         $('body').append('<div class="panel-backdrop"></div>');
         $('.page-container,header.navigation,.contact-info,footer').addClass("translateBody");
      }
      else{
         $('.page-container,header.navigation,.contact-info,footer').removeClass("translateBody");
         $(".panel-backdrop").remove();
      }
    }

    function changeHeader(scrollPos){
      if (scrollPos > 20) {
          $('.navigation').addClass('is-scrolled');
      } else {
          $('.navigation').removeClass('is-scrolled');
      }
    }

    function DetectAndServe(){
      if (getMobileOperatingSystem() == "Android") {
        window.open("https://play.google.com/store/apps/details?id=com.jobvim.expensetoday&pcampaignid=web_share");
      }
      else if (getMobileOperatingSystem() == "iOS") {
          window.open("https://apps.apple.com/cn/app/mioduvac/id6745430658");
      }
      else if (getMobileOperatingSystem() == "Windows Phone") {
        window.open("/");
      }
      else{
        window.open("/");
      }
    }

    function getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
          return "Android";
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
      }

      return "unknown";
    }

    setTimeout(function() {
        $('.loader').fadeOut('fast');
    }, 1000);

    jQuery("button.responsive-search-icon i.fa.fa-search").click(function(){
    jQuery(".search-section").addClass("menu-search-section");
     jQuery(".search-close").addClass("responsive-block");
  });

  jQuery(".search-close").click(function(){
    jQuery(" .search-section").removeClass("menu-search-section");
    jQuery(".search-close").removeClass("responsive-block");
  });

    var urlParams = new URLSearchParams(window.location.search);
    var signInHref = $(".custom-login-param a").attr("href");
    var pathname = "";

    // Handle 'f' parameter and rename it to 'referral_code'
    if (urlParams.has('f')) {
      urlParams.set('referral_code', urlParams.get('f'));
      urlParams.delete('f');
    }

    // Remove 'landing_page' parameter if it exists
    if (urlParams.has('landing_page')) {
      urlParams.delete('landing_page');
    }

    // Construct the new href based on the remaining parameters
    if (urlParams.toString() !== '') {
      var newHref = signInHref + '?' + urlParams.toString();
      newHref = newHref.replace(/%2F/g, '/'); // Decode encoded slashes
      $(".custom-login-param a").attr("href", newHref);
    } else {
      // Handle case with no query parameters
      pathname = location.pathname === '/' ? 'home' : location.pathname.replace(/^\/|\/$/g, '');
      var newHref = signInHref;
      $(".custom-login-param a").attr("href", newHref);
    }



